import axios from 'axios';
import { apiMainUrl, serverUrl } from '../../components/Helpers/Config';
import { tokenAuthorize } from '../../components/Helpers/Common';

export const EXPORT_LOADED = 'EXPORT_LOADED';
export const EXPORT_CREATED = 'EXPORT_CREATED';
export const EXPORT_PROCESS_LOADING = 'EXPORT_PROCESS_LOADING';
export const EXPORT_PROCESS_FAILED = 'EXPORT_PROCESS_FAILED';

export const exportShowcasePDF = (listshowcase, listpost) => {
    return (dispatch, getState) => {
        dispatch({ type: EXPORT_PROCESS_LOADING })

        let showcaseId = ""
        let showcaseId1 = {
            showcase_id: listshowcase.map(showcase => showcase.id)
        }

        showcaseId1.showcase_id?.map((r, ind) => (
            ind == 0 ? showcaseId += r : showcaseId += "," + r
        ))


        let postsId = ""
        let postsId1 = {
              reflection_id: listpost.map(reflection => reflection.reflection_id)
        }

        postsId1.reflection_id?.map((r, ind) => (
            ind == 0 ? postsId += r : postsId += "," + r
        ))

        let data = {
            showcase_id : showcaseId,
            reflection_id : postsId
        }
        
        return axios.post(
            serverUrl.ExportShowcasePdf, data,	
            {
                headers: { "Content-Type": "multipart/form-data" },
                responseType: "blob"
            }).then(resp => {
                if (resp.status === 200){
                    // const filename = resp.headers["content-disposition"].split("filename=")[1];
                    const filename = "showcase.pdf"
                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    dispatch({ type: EXPORT_LOADED })       
                    
                }
                else{
                    dispatch({ 
                        type: EXPORT_PROCESS_FAILED
                    })
                }

            }).catch((err) => {
                tokenAuthorize(err?.response?.status);
                dispatch({ 
                    type: EXPORT_PROCESS_FAILED, errors: [err]
                })

            })
    }
}



export const exportShowcaseHTML = (list) => {
    return (dispatch, getState) => {
        dispatch({ type: EXPORT_PROCESS_LOADING })
        let showcaseId = {
            showcase_id: list.map(showcase => showcase.id)
        }
        
        return axios.post(
            serverUrl.ExportShowcaseHtml, showcaseId,	
            {
                headers: { "Content-Type": "multipart/form-data" },
                responseType: "blob"
            })
            .then(resp => {
                if (resp.status === 200){
                    const filename = "showcase.zip"
                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    dispatch({ type: EXPORT_LOADED })
                }
                else{
                    dispatch({ 
                        type: EXPORT_PROCESS_FAILED
                    })
                }

            }).catch((err) => {
                tokenAuthorize(err?.response?.status);
                dispatch({ 
                    type: EXPORT_PROCESS_FAILED, errors: [err]
                })

            })
    }
}


export const exportPostPDF = (list) => {
    return (dispatch, getState) => {
        dispatch({ type: EXPORT_PROCESS_LOADING })

        let postId = "";

        let postId1 = {
            reflection_id: list.map(post => post.reflection_id)
        }

        postId1.reflection_id?.map((r, ind) => (
            ind == 0 ? postId += r : postId += "," + r
        ))

        let data = {
            showcase_id : null,
            reflection_id : postId
        }
        
        return axios.post(
            // serverUrl.ExportPostPdf, postId,	
            serverUrl.ExportShowcasePdf, data,
            {
                headers: { "Content-Type": "multipart/form-data" },
                responseType: "blob"
            })
            .then(resp => {
                if (resp.status === 200){
                    const filename = "post.pdf"
                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    dispatch({ type: EXPORT_LOADED })     
                }
                else{
                    dispatch({ 
                        type: EXPORT_PROCESS_FAILED
                    })
                }

            }).catch((err) => {
                tokenAuthorize(err?.response?.status);
                dispatch({ 
                    type: EXPORT_PROCESS_FAILED, errors: [err]
                })

            })
    }
}

export const exportPostHTML = (list) => {
    return (dispatch, getState) => {
        dispatch({ type: EXPORT_PROCESS_LOADING })
        let postId = {
            reflection_id: list.map(post => post.reflection_id)
        }
        
        return axios.post(
            serverUrl.ExportPostHtml,postId,	
            {
                headers: { "Content-Type": "multipart/form-data" },
                responseType: "blob"
            })
            .then(resp => {
                if (resp.status === 200){
                    const filename = "post.zip"
                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    dispatch({ type: EXPORT_LOADED })
                }
                else{
                    dispatch({ 
                        type: EXPORT_PROCESS_FAILED
                    })
                }

            }).catch((err) => {
                tokenAuthorize(err?.response?.status);
                dispatch({ 
                    type: EXPORT_PROCESS_FAILED, errors: [err]
                })

            })
    }
}

